import React, { Component } from "react";
import styled from "styled-components";
import * as vars from "../style/vars";
import { above, below } from "../style/functions";

class Article extends Component {
  render() {
    const { title, date, image, headline, content } = this.props;
    return (
      <ArticleWrapper>
        <div className="grid headline">
          <div className="inner">
            <h1 dangerouslySetInnerHTML={{ __html: headline }} />
            <p> {date}</p>
          </div>
        </div>
        <div className="grid">
          <img src={image.desktop} className="mobile-hide" />
          <img src={image.mobile} className="desktop-hide" />
          <div className="col col-12 content-container">
            <div className="col col-06 col-xs-12 title">
              <p className="large">{title}</p>
            </div>
            <div
              className="col col-06 col-xs-12 content"
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          </div>
        </div>
      </ArticleWrapper>
    );
  }
}

const ArticleWrapper = styled.div`
  img {
    width: 100%;
  }
  .content-container {
    padding-top: ${vars.padding.inner}rem;
  }
  .content-container .title {
    font-weight: bold;
    border-left: 1px solid ${vars.colors.offColor};
  }

  .content p {
    padding-left: ${vars.padding.inner / 4}rem;
    border-left: 1px solid ${vars.colors.offColor};
  }

  ${above.tablet`
  .headline {
    padding-top: ${vars.padding.inner * 5}rem;
    padding-bottom: ${vars.padding.inner * 3}rem;
  }
  .desktop-hide{
    display: none
  }
  .content-container {
    padding-left: ${vars.padding.inner * 3}rem;
    display: flex;
  }
  .title > p{
    max-width: 300px;
    padding-left: ${vars.padding.inner / 4}rem;
  }
  .content {
    -webkit-column-count: 2;
    -moz-column-count: 2;
    column-count: 2;
    -webkit-column-width: 150px;
    -moz-column-width: 150px;
    column-width: 200px;
  }
  `} 
  ${below.tablet`
  .mobile-hide{
    display: none
  }
  .headline {
    padding-top: ${vars.padding.inner}rem;
    padding-bottom: ${vars.padding.inner / 2}rem;
  }
  .title > p{
    padding-left: ${vars.padding.inner / 4}rem;
  }
`};
`;

export default Article;



// WEBPACK FOOTER //
// ./src/components/article.js